import React from "react";
import AppBar from "../app-bar/app-bar";
import DistributorsTable from "../data-tables-pharmacy/distributor/distributors-table";
import {useUser} from "../providers/user-context";

function DistributorsPage({navOpen, toggleNav}) {
    const {userFullName, tenantName, tenantType} = useUser();
    return (
        <div style={{ display: 'flex', marginTop: '60px' }}>
            <AppBar userFullName={userFullName} tenantName={tenantName} type={tenantType} navOpen={navOpen} toggleNav={toggleNav}/>
            {tenantType === "PHARMACY" && <DistributorsTable navOpen={navOpen}/>}
        </div>
    );
}
export default DistributorsPage;
